import React, {useState} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import ModalByProps from '#components/m/ModalByProps'
import Button from '#components/a/Button'
import AbteilungenVerwaltenModalContent from '#components/o/AbteilungenVerwaltenModalContent'

function AbteilungenVerwaltenModal({ausbilder, triggerButtonModifier, handleSave}) {
  const [showModal, setShowModal] = useState(false)
  const closeModal = () => setShowModal(false)

  return (
    <div>
      <Button
        text={i18n.t('meine_ausbilder_abteilungen_verwalten')}
        modifiers={[triggerButtonModifier]}
        event={() => setShowModal(true)}
      />
      <ModalByProps modalIsOpen={showModal} modifier="large">
        <AbteilungenVerwaltenModalContent ausbilder={ausbilder} closeModal={closeModal} handleSave={handleSave} />
      </ModalByProps>
    </div>
  )
}

AbteilungenVerwaltenModal.propTypes = {
  ausbilder: PropTypes.shape({
    id: PropTypes.number,
    abteilungen: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        backgroundColor: PropTypes.string,
        textColor: PropTypes.string,
      }),
    ),
  }).isRequired,
  triggerButtonModifier: PropTypes.string.isRequired,
  handleSave: PropTypes.func.isRequired,
}

export default AbteilungenVerwaltenModal
